import { useI18n } from "@/lib/i18n";

const NL = [
  ["1. Uitsluitend voor onderzoek", "Alle producten aangeboden op peptivance.eu zijn uitsluitend bedoeld voor in-vitro onderzoek in een gecontroleerde laboratoriumsetting. Ze zijn niet ontworpen, geproduceerd of geleverd voor gebruik door mensen of dieren."],
  ["2. Geen medische claims", "Peptivance maakt geen enkele medische, therapeutische of preventieve claim omtrent haar producten. Producten zijn niet goedgekeurd door de EMA, FDA of enige andere geneesmiddelenautoriteit."],
  ["3. Verantwoordelijkheid koper", "Door een aankoop te doen, bevestigt de koper: (a) 18 jaar of ouder te zijn; (b) gekwalificeerd te zijn om onderzoeksmaterialen te hanteren; (c) de producten uitsluitend te gebruiken voor onderzoeksdoeleinden en niet voor menselijke of dierlijke consumptie."],
  ["4. Naleving van lokale wetgeving", "De koper is verantwoordelijk voor naleving van alle toepasselijke lokale, nationale en internationale wetgeving met betrekking tot import, bezit en gebruik van deze materialen."],
  ["5. Aansprakelijkheid", "Peptivance is niet aansprakelijk voor enig gebruik van haar producten buiten de aangegeven onderzoekscontext."],
];

const EN = [
  ["1. For research use only", "All products offered on peptivance.eu are intended exclusively for in-vitro research in a controlled laboratory setting. They are not designed, manufactured, or supplied for use in humans or animals."],
  ["2. No medical claims", "Peptivance makes no medical, therapeutic, or preventive claim regarding its products. Products are not approved by EMA, FDA, or any other pharmaceutical regulatory authority."],
  ["3. Buyer responsibility", "By making a purchase, the buyer confirms: (a) being 18 years or older; (b) being qualified to handle research materials; (c) using the products exclusively for research purposes and not for human or animal consumption."],
  ["4. Compliance with local law", "The buyer is responsible for compliance with all applicable local, national, and international laws regarding import, possession, and use of these materials."],
  ["5. Liability", "Peptivance is not liable for any use of its products outside the stated research context."],
];

export default function Disclaimer() {
  const { t, lang } = useI18n();
  const items = lang === "nl" ? NL : EN;
  return (
    <div data-testid="disclaimer-page" className="pt-32 pb-24 bg-[#F7F7F6] min-h-screen">
      <div className="max-w-[1000px] mx-auto px-6 md:px-12">
        <p className="font-mono-label text-[11px] text-neutral-500 mb-8">[ LEGAL / DISCLAIMER ]</p>
        <h1 className="font-serif-display font-light text-5xl md:text-7xl leading-[0.98] mb-16">{t("disclaimer_title")}</h1>

        <div className="border-t border-neutral-300">
          {items.map(([title, body], i) => (
            <div key={i} className="border-b border-neutral-300 py-10 grid md:grid-cols-12 gap-8">
              <div className="md:col-span-1 font-mono-label text-[10px] text-neutral-500">0{i + 1}</div>
              <div className="md:col-span-4">
                <h2 className="font-serif-display text-2xl md:text-3xl leading-tight">{title}</h2>
              </div>
              <div className="md:col-span-7">
                <p className="text-neutral-600 leading-relaxed">{body}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-16 font-mono-label text-[10px] text-neutral-500">
          Last updated: {new Date().toLocaleDateString(lang === "nl" ? "nl-NL" : "en-GB")}
        </p>
      </div>
    </div>
  );
}
